import React from 'react';
import { Design, Display, Pillar } from '@guardian/types';
import { RichLink } from '@root/src/web/components/RichLink';
export const DefaultRichLink = ({ index, headlineText, url, isPlaceholder, }) => {
    return (React.createElement(RichLink, { richLinkIndex: index, cardStyle: "news", thumbnailUrl: "", headlineText: headlineText, contentType: "article", url: url, format: {
            display: Display.Standard,
            design: Design.Article,
            theme: Pillar.News,
        }, tags: [], sponsorName: "", isPlaceholder: isPlaceholder }));
};
